// extracted by mini-css-extract-plugin
export default {"page":"myBusiness_page__f7jNR","lodingContainer":"myBusiness_lodingContainer__7gGl6"};